// extracted by mini-css-extract-plugin
export default {"mobileMenu":"MobileMenu_mobileMenu__pr7eF","open":"MobileMenu_open__N2m3T","divider":"MobileMenu_divider__4lOIo"};